import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Collapse } from 'wanderu-animations';
import A from 'wanderu-component-react-router-link';
import {
    Button,
    CaretIcon,
} from 'wanderu-components';

import TripOptions from '../TripOptions/TripOptions';

import styles from './Submenu.scss';

class Submenu extends Component {
    static propTypes = {
        href: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        locale: PropTypes.string,
        linkKey: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    static defaultProps = {
        onClick() { },
        locale: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    _toggleOpen = () => {
        this.setState((oldState) => ({ isOpen: !oldState.isOpen }));
    };

    render() {
        const {
            listType,
            title,
            href,
            onClick,
            locale,
            options,
            linkKey,
        } = this.props;
        const { isOpen } = this.state;

        return (
            <div className={styles.row}>
                <div
                    className={styles.header}
                    id={listType}
                >
                    <A
                        className={styles.title}
                        href={href}
                        onClick={onClick}
                    >
                        {title}
                    </A>
                    <Button
                        aria-controls={`${listType}-collapse`}
                        aria-expanded={isOpen}
                        className={styles.rowButton}
                        data-id="toggleRow"
                        onClick={this._toggleOpen}
                        type="button"
                        unstyled
                    >
                        <CaretIcon showUpArrow={isOpen} />
                    </Button>
                </div>
                <Collapse
                    aria-label={listType}
                    duration={500}
                    id={`${listType}-collapse`}
                    isOpen={isOpen}
                >
                    <TripOptions
                        className={styles.options}
                        linkKey={linkKey}
                        locale={locale}
                        onClick={onClick}
                        optionClassName={styles.option}
                        options={options}
                    />
                </Collapse>
            </div>
        );
    }
}

export default Submenu;
